import { FeatureFlag, FeatureFlagABTest } from "./flags";

import { useFlag } from "@unleash/proxy-client-react";
import { useAnalytics } from "Store/analytics/analyticsHooks";
import { setFeatureFlagUsed } from "Store/analytics/analyticsSlice";
import { useEffect } from "react";
import { useDispatch } from "react-redux";

export const useUnleashFeatureFlag = (flag: FeatureFlag): boolean => {
  const dispatch = useDispatch();
  const { usedFeatureFlags } = useAnalytics();
  const flagUsed = useFlag(flag);
  useEffect(() => {
    if (flagUsed && !usedFeatureFlags.includes(flag)) {
      dispatch(setFeatureFlagUsed(flag));
    }
  }, [flagUsed]);
  return flagUsed;
};

export function useABTestingFeature(featureFlag: FeatureFlagABTest): boolean {
  const isFlagEnabled = useFlag(featureFlag);

  useEffect(() => {
    window.dataLayer.push({
      event: "use_feature",
      eventModel: {
        feature_context: "ssx2",
        feature_flags: [`abtest-${featureFlag}-${isFlagEnabled ? "1" : "0"}`],
        page_type: "e-commerce",
        traffic_type: "internal",
      },
    });
  }, [featureFlag, isFlagEnabled]);

  return isFlagEnabled;
}
